import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarLink from './SidebarLink';
import SidebarCategory from './SidebarCategory';

class SidebarContent extends Component {
  static propTypes = {
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    viewPageAs: PropTypes.number.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  showAdminMenu = show => (
    show ? (
      <>
        <SidebarCategory title="Administraci&oacute;n" icon="diamond">
          <SidebarLink title="Usuarios" route="/pages/users" onClick={this.hideSidebar} />
          <SidebarLink title="Carreras" route="/pages/one" onClick={this.hideSidebar} />
          <SidebarLink title="Materias" route="/pages/subjects" onClick={this.hideSidebar} />
          <SidebarLink title="Materias por periodo" route="/pages/subjects-periods" onClick={this.hideSidebar} />
          <SidebarLink title="Periodos" route="/pages/periodos" onClick={this.hideSidebar} />
          <SidebarLink title="Mallas" route="/pages/mallas" onClick={this.hideSidebar} />
          <SidebarLink title="Auditor&iacute;a" route="/pages/audit_log" onClick={this.hideSidebar} />
        </SidebarCategory>
        <SidebarCategory title="Alumnos" icon="diamond">
          <SidebarLink title="Inscripcion" route="/pages/students" onClick={this.hideSidebar} />
          <SidebarLink
            title="Inscripcion a materias"
            route="/pages/student-subjects"
            onClick={this.hideSidebar}
          />
          <SidebarLink
            title="Reporte de alumnos inscriptos"
            route="/pages/reporte-inscripcion"
            onClick={this.hideSidebar}
          />
          <SidebarLink
            title="Reporte de alumnos"
            route="/pages/reporte-alumnos"
            onClick={this.hideSidebar}
          />
          <SidebarLink
            title="Reporte de Asistencia y PP"
            route="/pages/reporte-alumnos-por-materias"
            onClick={this.hideSidebar}
          />
          <SidebarLink title="Examenes" route="/pages/exams" onClick={this.hideSidebar} />
        </SidebarCategory>
        <SidebarCategory title="Profesores" icon="diamond">
          <SidebarLink title="Asistencia" route="/pages/one" onClick={this.hideSidebar} />
          <SidebarLink title="Contenido Programa" route="/pages/two" onClick={this.hideSidebar} />
        </SidebarCategory>
      </>
    ) : null
  );

  showStudentMenu = show => (
    show ? (
      <>
        <SidebarLink
          title="Tablero"
          route="/pages/student-dashboard"
          onClick={this.hideSidebar}
        />
        <SidebarLink
          title="Mis materias"
          route="/pages/student-subjects"
          onClick={this.hideSidebar}
        />
        <SidebarLink
          title="Mis ex&aacute;menes"
          route="/pages/student-exams"
          onClick={this.hideSidebar}
        />
      </>
    ) : null
  );

  showProfessorMenu = show => (
    show ? (
      <>
        <SidebarLink
          title="Tablero"
          route="/pages/profesor-dashboard"
          onClick={this.hideSidebar}
        />

        <SidebarLink
          title="Mis materias"
          route="/pages/profesor-subjects"
          onClick={this.hideSidebar}
        />

        <SidebarLink
          title="Mis ex&aacute;menes"
          route="/pages/exams"
          onClick={this.hideSidebar}
        />
      </>
    ) : null
  );

  showReportMenu = ({ isStudentMenu, isAdminMenu }) => {
    if (!(isStudentMenu || isAdminMenu)) {
      return null;
    }

    if (isAdminMenu) {
      return (
        <SidebarCategory title="Reporte" icon="diamond">
          <SidebarLink
            title="Reporte de Registro de Contenido"
            route="/pages/content-record"
            onClick={this.hideSidebar}
          />
          <SidebarLink
            title="Estado acad&eacute;mico"
            route="/pages/reporte-alumnos/academic-status"
            onClick={this.hideSidebar}
          />
        </SidebarCategory>
      );
    }

    return (
      <SidebarCategory title="Reporte" icon="diamond">
        <SidebarLink
          title="Estado acad&eacute;mico"
          route="/pages/reporte-alumnos/academic-status"
          onClick={this.hideSidebar}
        />
      </SidebarCategory>
    );
  };

  render() {
    const { changeToDark, changeToLight, viewPageAs } = this.props;
    const user = JSON.parse(localStorage.getItem('currentUser')) || {};

    const isAdminMenu = viewPageAs === 2 || viewPageAs === 3;

    const isProfessorMenu = user.esProfesor
      && (viewPageAs === 1 || (user.esProfesor && !user.esFuncionario && !user.esAlumno && !user.esAdmin));

    const isStudentMenu = user.esAlumno
      && (viewPageAs === 0 || (user.esAlumno && !user.esFuncionario && !user.esProfesor && !user.esAdmin));

    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          <SidebarCategory title="Tema" icon="layers">
            <button type="button" className="sidebar__link" onClick={changeToLight}>
              <p className="sidebar__link-title">Tema Claro</p>
            </button>
            <button type="button" className="sidebar__link" onClick={changeToDark}>
              <p className="sidebar__link-title">Tema Oscuro</p>
            </button>
          </SidebarCategory>
        </ul>
        <ul className="sidebar__block">
          {this.showAdminMenu(isAdminMenu)}
          {this.showStudentMenu(isStudentMenu)}
          {this.showProfessorMenu(isProfessorMenu)}
          {this.showReportMenu({
            isStudentMenu,
            isAdminMenu,
          })}
        </ul>
      </div>
    );
  }
}

export default SidebarContent;
